{
  "breakpoint": {
    "breakpoint-xs": "480px",
    "breakpoint-sm": "768px",
    "breakpoint-md": "992px",
    "breakpoint-lg": "1200px",
    "breakpoint-xl": "1600px"
  }
}
